module.exports = __webpack_public_path__ + "static/media/DBHeaventNow-Bold.be3d257a.woff";